import Button from '@components/Button';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';

interface Params {
    message: string;
}

declare module '@stackflow/config' {
    interface Register {
        AlertActivity: Params;
    }
}

const AlertActivity: ActivityComponentType<'AlertActivity'> = ({ params }) => {
    const { message } = params;
    const { pop } = useFlow();
    return (
        <Modal>
            <ModalContainer>
                <Text>{message}</Text>
                <Button onClick={pop}>닫기</Button>
            </ModalContainer>
        </Modal>
    );
};

export default AlertActivity;
